export const infoData = [
  { id: "ready", name: "READY" },
  { id: "unknown", name: "UNKNOWN" },
  { id: "aborted", name: "ABORTED" },
  { id: "unlicenced", name: "UNLICENCED" },
  { id: "badargs", name: "BAD ARGS" },
  { id: "noaddress", name: "NO ADDRESS" },
  { id: "badargrange", name: "BAD ARG RANGE" },
  { id: "badargsource", name: "BAD ARG SOURCE ADDRESS" },
  { id: "badparameter", name: "BAD PARAMETERS" },
  { id: "unknownhost", name: "UNKNOWN HOST" },
  { id: "inprogress", name: "IN PROGRESS" },
  { id: "passed2", name: "PASSED" },
  { id: "maxttlexceeded", name: "MAX TTL EXCEEDED" },
  { id: "hopunreachable", name: "HOP UNREACHABLE" },
  { id: "dnsfailed", name: "DNS FAILED" }
];



// WEBPACK FOOTER //
// ./src/components/common/results/views/traceroute/infoenum.js